import type { ListFeedbackResponse } from '@shared/schemas';

export type LoadStatus = 'idle' | 'loading' | 'loaded' | 'failed';

/**
 * Redux state for the admin List Feedbacks page and its sidebar badge (#717).
 *
 * `openCount` lives here rather than in the SideNav so that a status change on
 * the page and the badge read one number. `null` until first loaded (no badge
 * rather than a wrong 0). Which row's panel is open stays local to the page:
 * it is driven by the `?feedback=` address.
 */
export interface ListFeedbacksState {
  feedbacks: ListFeedbackResponse[];
  loadStatus: LoadStatus;
  openCount: number | null;
  /** The feedback whose status is being saved, and the last save's error. */
  statusUpdate: { pendingId: string | null; error: string | null };
}

export const initialState: ListFeedbacksState = {
  feedbacks: [],
  loadStatus: 'idle',
  openCount: null,
  statusUpdate: { pendingId: null, error: null },
};
